export function homePage() {
    $.fn.extend({
        toggleText: function (a, b) {
            return this.text(this.text() == b ? a : b);
        },
    });

    $('.main-slider').slick({
        speed: 500,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed:3000,
    });

    $('.tours-slider').slick({
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });

    $('.locations-slider').slick({
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    $('.locations-wrapper .prev').click(function () {
        $('.locations-slider').slick('slickPrev');
    });
    $('.locations-wrapper .next').click(function () {
        $('.locations-slider').slick('slickNext');
    });

    $(function () {
        $('.main-slider-wrapper .prev').click(function () {
            $('.main-slider').slick('slickPrev');
        });
        $('.main-slider-wrapper .next').click(function () {
            $('.main-slider').slick('slickNext');
        });


        window.autoLightframe_HomePage = function() {
            FH.autoLightframe({
                callback: function () {
                    $.fancybox.close();
                },
            });
        };

        (window.waitForFH_HomePage = function() {
            if (!window.FH) {
                setTimeout(window.waitForFH_HomePage, 50);
                return;
            }
            autoLightframe_HomePage();
        })();

        $('.show-more-button').click(function () {
            $(this).parents('.content-holder').toggleClass('passive');
            $(this).toggleText('Show more', 'Show less');
        });

        $('.tours-slider-wrapper .prev').click(function () {
            $('.tours-slider').slick('slickPrev');
        });
        $('.tours-slider-wrapper .next').click(function () {
            $('.tours-slider').slick('slickNext');
        });
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/home.js